<template>
  <div id="modalNewUserGuide">
    <ModalBox width="672px" :showModal.sync="showModal">
      <template slot="header">
        <h2>{{ $t("SuggestionForNewUsers") }}</h2>
      </template>
      <template slot="body">
        <h3>{{ $t("Start_With_PEAK_Payroll") }}</h3>
        <!-- video -->
        <div class="video">
          <iframe
            width="632"
            height="356"
            src="https://www.youtube.com/embed/pWwQpuP8k10?rel=0"
            title="YouTube video player"
            frameborder="0"
            allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
            allowfullscreen
            class="iframe"
          ></iframe>
        </div>

        <h3 class="mt-4">{{ $t("Choose_Interested_Option") }}</h3>
        <div class="cardContainer">
          <div class="card" @click="onCLickWatchVideo">
            <img
              height="100"
              :src="
                peakFileServer.UrlCombine('peakengine/Content/Image/PeakPayroll/PeakPayroll_NewUserGuide_Video.png')
              "
              alt="PeakPayroll_NewUserGuide_Video"
            />
            <p class="cardHeader">{{ $t("Watch_Introductory_Video") }}</p>
            <p class="cardDescription" v-html="$t('Watch_Introductory_Video_Detail')"></p>
          </div>
          <div class="card" @click="onClickUserManual">
            <img
              height="100"
              :src="
                peakFileServer.UrlCombine('peakengine/Content/Image/PeakPayroll/PeakPayroll_NewUserGuide_Manual.png')
              "
              alt="PeakPayroll_NewUserGuide_Manual"
            />
            <p class="cardHeader">{{ $t("Peak_Payroll_UserManual") }}</p>
            <p class="cardDescription" v-html="$t('Peak_Payroll_UserManual_Detail')"></p>
          </div>
        </div>
      </template>
    </ModalBox>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class ModalNewUserGuide extends Vue {
  private showModal = true;
  private peakFileServer = process.env.VUE_APP_PeakFileServer;

  @Watch("showModal")
  showModalChanged(newVal: boolean) {
    if (!newVal) {
      this.HideModal();
    }
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }

  public onCLickWatchVideo() {
    window.open("https://www.youtube.com/playlist?list=PLKx_LgGwE9YMT3LhpKID8Y1OTVy4wBjM9", "_blank");
  }
  public onClickUserManual() {
    window.open(
      "https://sites.google.com/peakengine.com/help-center/%E0%B8%84%E0%B8%A1%E0%B8%AD-%E0%B8%A8%E0%B8%99%E0%B8%A2%E0%B8%A3%E0%B8%A7%E0%B8%A1%E0%B9%81%E0%B8%AD%E0%B8%9B%E0%B8%9E%E0%B8%A5%E0%B9%80%E0%B8%84%E0%B8%8A%E0%B8%99/peak-payroll",
      "_blank"
    );
  }
}
</script>

<style lang="scss" scoped>
#modalNewUserGuide {
  .cardContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 16px 0;
    align-items: stretch;
  }
  .card {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid $gray_default;
    border-radius: 4px;
    padding: 16px;
    width: 100%;
    min-height: 212px;
    cursor: pointer;
  }
  .cardHeader {
    @include font("bold");
    color: $text;
    text-align: center;
  }
  .cardDescription {
    font-size: 14px;
    color: $text;
    text-align: center;
  }

  .video {
    overflow: hidden;
    @include shadowboxLv2;
    border-radius: 10px;
    margin: 16px 0;
  }
  .iframe {
    vertical-align: top;
    aspect-ratio: 16 / 9;
    height: auto;
    width: 100%;
  }
}
</style>
